import apiClient from './api';
import { API_ENDPOINTS } from '@/config/api';

export interface LoginCredentials {
  email: string;
  password: string;
}

export interface Platform {
  id: string;
  name: string;
  shortDescription: string;
  internalUrl: string;
  externalUrl: string;
  logoBase64: string;
}

export interface User {
  email: string;
  name: string;
  platforms: Platform[];
}

export interface ApiResponse<T> {
  success: boolean;
  status: string;
  data: T;
  errorMessage: string | null;
}

export interface ExcelAuthResponse {
  accessToken: string;
  refreshToken: string;
  user: User;
}

export const authService = {
  // Excel Bearer auth
  async excelLogin(credentials: LoginCredentials): Promise<ExcelAuthResponse> {
    const response = await apiClient.post<ApiResponse<ExcelAuthResponse>>(
      API_ENDPOINTS.EXCEL_AUTH.LOGIN,
      credentials
    );
    return response.data.data;
  },

  async excelRefreshToken(refreshToken: string): Promise<ExcelAuthResponse> {
    const response = await apiClient.post<ApiResponse<ExcelAuthResponse>>(
      API_ENDPOINTS.EXCEL_AUTH.REFRESH_TOKEN,
      { refreshToken }
    );
    return response.data.data;
  },

  // Web cookie-based auth (unchanged)
  async login(credentials: LoginCredentials): Promise<User> {
    const response = await apiClient.post<ApiResponse<User>>(API_ENDPOINTS.AUTH.LOGIN, credentials);
    return response.data.data;
  },

  async logout(): Promise<void> {
    await apiClient.post(API_ENDPOINTS.AUTH.LOGOUT);
  },

  async refreshToken(): Promise<User> {
    const response = await apiClient.post<ApiResponse<User>>(API_ENDPOINTS.AUTH.REFRESH_TOKEN);
    return response.data.data;
  },
};
